import createReducer from 'reducers/createReducer';

import { Inventory } from 'actions/actionTypes';

const INITIAL_STATE = {
    // 보유하고 있는 아이템 정보
    data: null,
    isOwnItem: false,
    prevPurchaseShopItem: null,
    purchaseShopItem: 0,
    resetTimer: 0,
    resetLevel: 0,
    error: {
        triggered: false,
        message: '',
    },
};

const reducer = createReducer(INITIAL_STATE, {
    // 내 보관함 목록
    [Inventory.LOAD_INVENTORY_LIST_REQUEST] : (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Inventory.LOAD_INVENTORY_LIST_SUCCESS] : (state, action) => {
        state.data = action.payload;
        state.isOwnItem = true;
        const prevItemArray = action.payload.filter((item) =>item.prevPurchaseShopItem !== null)
        let prevItem = [];
        prevItemArray.map((item)=>(
            prevItem.push(item.prevPurchaseShopItem)
        ))
        state.prevPurchaseShopItem = prevItem;
    },
    [Inventory.LOAD_INVENTORY_LIST_FAILURE] : (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload?.errorMessage,
        };
    },
    // 구매 완료 아이템 아이디 저장
    [Inventory.PURCHASE_SHOP_ITEM_ID]: (state, action) => {
        state.purchaseShopItem = parseInt(action.payload);
    },
    // 아이템 알림 팝업 지속 노출
    [Inventory.RESET_TIMER]: (state, action) => {
        state.resetTimer = state.resetTimer + 1;
        state.resetLevel = parseInt(action.payload);
    },
})

export default reducer;